import './FrameworkFilters.scss';

import React from 'react';

import Filter from './Filter';
import { FrameworkFilters as Filters } from './useFrameworkFilters';

interface Props {
  filters: Filters;
}

const FrameworkFilters: React.FC<Props> = (props) => {
  const { filters } = props;

  if (filters.attributes.every((f) => f.attributes.length === 0)) {
    return null;
  }

  return (
    <div className="FrameworkFilters">
      <h4 className="FrameworkFilters-label">Filter Frameworks</h4>

      <div className="FrameworkFilters-filters">
        {filters.filters.map((_, index) => (
          <Filter key={index} index={index} filters={filters} />
        ))}
        {filters.filters.every(
          (f) => f.attribute != null && f.value != null
        ) && <Filter index={filters.filters.length} filters={filters} />}
      </div>
    </div>
  );
};

export default FrameworkFilters;
